import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/bus-bg.jpg";
import aboutTaxi from "../assets/about-taxi.jpg";
import aboutTaxi2 from "../assets/3.jpeg";
import bus from "../assets/bus.png";

function About() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                {/* Background */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/60" />

                {/* Content */}
                <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="mb-4 text-4xl font-extrabold sm:text-5xl md:text-6xl"
                    >
                        About Richie Travel
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="max-w-2xl text-sm text-gray-200 sm:text-base"
                    >
                        Reliable Taxi & Tour Services Across Sri Lanka
                    </p>
                </div>
            </section>

            {/* ================= ABOUT US SECTION ================= */}
            <section className="w-full bg-white py-10">
                <div className="mx-auto max-w-7xl px-4">
                    <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">

                        <div
                            data-aos="fade-right"
                            className="relative h-[450px] w-full overflow-hidden rounded-xl md:h-[500px]"
                        >
                            <img
                                src={aboutTaxi}
                                alt="Taxi Service"
                                className="h-full w-full object-fill"
                            />

                            {/* Experience Badge */}
                            <div className="absolute bottom-0 left-0 w-full bg-yellow-400 py-0 text-center">
                                <h3 className="text-1xl font-extrabold text-black sm:text-2xl">
                                    More Than 20 Years <br /> of Experience
                                </h3>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div data-aos="fade-left">
                            <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-yellow-500">
                                About Us
                            </p>

                            <h2 className="mb-6 text-3xl font-extrabold text-black sm:text-4xl">
                                Driving Trust and <br /> Excellence
                            </h2>

                            <p className="mb-6 text-gray-700 leading-relaxed">
                                Richie Travel is one of the most popular, reliable, safe, and
                                comfortable tourist taxi service companies in Sri Lanka. We offer
                                high-quality, on-time taxi services and tours using a wide range of
                                vehicles with professional, experienced drivers.
                            </p>

                            {/* FEATURES */}
                            <ul className="space-y-3">
                                <li className="flex items-start gap-3">
                                    <span className="text-yellow-500">✔</span>
                                    <span className="text-gray-700">
                                        Reliable and punctual tour transport services
                                    </span>
                                </li>

                                <li className="flex items-start gap-3">
                                    <span className="text-yellow-500">✔</span>
                                    <span className="text-gray-700">
                                        Airport transfers, city tours, day trips & tour packages
                                    </span>
                                </li>

                                <li className="flex items-start gap-3">
                                    <span className="text-yellow-500">✔</span>
                                    <span className="text-gray-700">
                                        Logistics and freight transport services
                                    </span>
                                </li>

                                <li className="flex items-start gap-3">
                                    <span className="text-yellow-500">✔</span>
                                    <span className="text-gray-700">
                                        Hassle-free hotel booking with competitive rates
                                    </span>
                                </li>

                                <li className="flex items-start gap-3">
                                    <span className="text-yellow-500">✔</span>
                                    <span className="text-gray-700">
                                        24/7 professional customer support
                                    </span>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </section>

            {/* ================= EXTRA ABOUT DESCRIPTION ================= */}
            <section className="w-full bg-white py-10">
                <div className="mx-auto max-w-7xl px-4">
                    <div className="grid grid-cols-1 gap-12 md:grid-cols-2 items-start">

                        {/* LEFT TEXT CONTENT */}
                        <div data-aos="fade-right">
                            <h2 className="mb-6 text-3xl font-extrabold text-black sm:text-4xl">
                                We Are The Most Popular Logistics <br />
                                And Transportation Company.
                            </h2>

                            <p className="mb-5 text-gray-700 leading-relaxed">
                                At Richie Travel, we take pride in providing exceptional transportation
                                and travel services to our valued customers. With a strong commitment
                                to customer satisfaction, we strive to create unforgettable experiences
                                and ensure that every journey is safe, comfortable, and enjoyable.
                            </p>

                            <p className="mb-5 text-gray-700 leading-relaxed">
                                With years of experience in the travel and transportation industry,
                                our team brings a wealth of expertise and knowledge to meet your needs.
                                Our drivers, tour guides, and staff are highly skilled professionals
                                who are passionate about delivering top-notch service.
                            </p>

                            <p className="mb-5 text-gray-700 leading-relaxed">
                                Customer focus is at the heart of everything we do. Whether you’re
                                looking for memorable tours, reliable logistics, or hassle-free hotel
                                bookings, we tailor our services to match your preferences.
                            </p>

                            <p className="mb-5 text-gray-700 leading-relaxed">
                                Quality is our priority. From meticulously maintained vehicles to
                                strict safety protocols, we ensure your journey is not only comfortable
                                but also secure.
                            </p>

                            <p className="text-gray-700 leading-relaxed">
                                Thank you for choosing Richie Travel. We look forward to being part of
                                your journey and creating memories that last a lifetime.
                            </p>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div
                            data-aos="fade-left"
                            className="relative h-[300px] sm:h-[400px] md:h-[600px] overflow-hidden rounded-xl"
                        >
                            <img
                                src={aboutTaxi2}
                                alt="Taxi Service"
                                className="h-full w-full object-cover"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= SERVICES SECTION ================= */}
            <section className="w-full bg-gray-100 py-14">
                <div className="mx-auto max-w-7xl px-4">

                    {/* Heading */}
                    <div className="mb-12 text-center">
                        <p
                            data-aos="fade-up"
                            className="mb-2 text-sm font-semibold uppercase tracking-widest text-yellow-500"
                        >
                            More Services
                        </p>
                        <h2
                            data-aos="fade-up"
                            data-aos-delay="100"
                            className="text-3xl font-extrabold text-black sm:text-4xl"
                        >
                            Offering a Wide Range Services
                        </h2>
                    </div>

                    {/* Service Cards */}
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-2">

                        {/* Airport Transfers */}
                        <div
                            data-aos="zoom-in"
                            className="flex h-[260px] items-center justify-center rounded-xl bg-gradient-to-br from-yellow-500 via-orange-500 to-red-500 p-8 text-center text-white shadow-lg"
                        >
                            <div>
                                <h3 className="mb-2 text-2xl font-bold">
                                    Airport Transfers
                                </h3>
                                <p className="text-l text-white/90">
                                    Reliable and punctual airport transfers ensuring a smooth
                                    start or end to your journey.
                                </p>
                            </div>
                        </div>

                        {/* Corporate Travel */}
                        <div
                            data-aos="zoom-in"
                            data-aos-delay="150"
                            className="flex h-[260px] items-center justify-center rounded-xl bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 p-8 text-center text-white shadow-lg"
                        >
                            <div>
                                <h3 className="mb-2 text-2xl font-bold">
                                    Corporate Travel
                                </h3>
                                <p className="text-l text-white/90">
                                    Tailored transportation solutions for corporate clients
                                    with comfort and efficiency.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= WHY CHOOSE US ================= */}
            <section className="w-full bg-black py-14 text-white">
                <div className="mx-auto max-w-7xl px-4 text-center">

                    <h2
                        data-aos="fade-up"
                        className="mb-6 text-3xl font-extrabold sm:text-4xl"
                    >
                        Why Choose Us
                    </h2>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="100"
                        className="mx-auto mb-10 max-w-3xl text-gray-300"
                    >
                        Richie Travel delivers reliable, safe, and comfortable transportation
                        solutions with professional drivers, modern vehicles, and excellent
                        customer care.
                    </p>

                    {/* Progress Bars */}
                    <div className="mx-auto max-w-4xl space-y-6">

                        {/* Experience */}
                        <div data-aos="fade-up">
                            <div className="mb-1 flex justify-between text-sm">
                                <span>Experience</span>
                                <span>95%</span>
                            </div>
                            <div className="h-2 w-full bg-gray-700">
                                <div className="h-2 w-[95%] bg-yellow-400" />
                            </div>
                        </div>

                        {/* Safety */}
                        <div data-aos="fade-up" data-aos-delay="100">
                            <div className="mb-1 flex justify-between text-sm">
                                <span>Safety</span>
                                <span>95%</span>
                            </div>
                            <div className="h-2 w-full bg-gray-700">
                                <div className="h-2 w-[95%] bg-yellow-400" />
                            </div>
                        </div>

                        {/* Comfort */}
                        <div data-aos="fade-up" data-aos-delay="200">
                            <div className="mb-1 flex justify-between text-sm">
                                <span>Comfort</span>
                                <span>90%</span>
                            </div>
                            <div className="h-2 w-full bg-gray-700">
                                <div className="h-2 w-[90%] bg-yellow-400" />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= TAXI CTA SECTION ================= */}
            <section className="w-full bg-[#f7f7f7] py-16">
                <div className="mx-auto max-w-7xl px-4">
                    <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2">

                        {/* LEFT CONTENT */}
                        <div
                            data-aos="fade-right"
                            className="flex flex-col items-center text-center"
                        >
                            <h2 className="mb-4 text-3xl font-extrabold text-black sm:text-4xl">
                                Book your Taxi Today!
                            </h2>

                            <p className="mb-6 max-w-xl text-gray-700">
                                Richie Travel is the best and no.1 Taxi & Tour service provider in Sri
                                Lanka. We always offer you the best Taxi deals covering all islands.
                            </p>

                            <p className="mb-6 text-2xl font-bold text-black">
                                +94 70 515 2858
                            </p>

                            <a
                                href="tel:+94743205692"
                                className="inline-block rounded bg-black px-8 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-gray-900"
                            >
                                Contact Us
                            </a>
                        </div>


                        {/* RIGHT IMAGE */}
                        <div
                            data-aos="fade-left"
                            className="flex justify-center md:justify-end"
                        >
                            <img
                                src={bus}
                                alt="Taxi Service"
                                className="max-w-full object-contain"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94705152858"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default About;
